import { ForwardedRef, forwardRef } from 'react';
import { Typography } from '@material-ui/core';

import { useSuperSmallCaptionStyles } from './Typography.styles';
import { TypographyProps } from './Typography.props';

/**
 * Typography.SuperSmallCaption component
 * @returns {JSX.Element}
 */
export const SuperSmallCaption = forwardRef(
  ({ className = '', ...props }: TypographyProps, ref: ForwardedRef<HTMLElement>): JSX.Element => {
    const styles = useSuperSmallCaptionStyles();

    return <Typography classes={styles} className={className} {...props} {...{ ref }} />;
  },
);

SuperSmallCaption.displayName = 'Typography.SuperSmallCaption';
